import { forwardRef } from "react";
import "./Select.scss";

export type SelectSize = "small" | "default" | "large";

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "size"> {
  label?: React.ReactNode;
  // Core props
  size?: SelectSize;
  block?: boolean;

  // Visual modifiers
  rounded?: boolean;
  hasError?: boolean;

  // Icons
  iconName?: string;

  // Content
  children?: React.ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      size = "default",
      block = false,
      rounded = false,
      hasError = false,
      iconName = "expand_more",
      disabled = false,
      label,
      className = "",
      children,
      ...props
    },
    ref,
  ) => {
    const classes = [
      "select",
      `select--${size}`,
      block && "select--block",
      rounded && "select--rounded",
      hasError && "select--error",
      disabled && "select--disabled",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    const selectElement = (
      <div className={classes}>
        <select ref={ref} className="select__input" disabled={disabled} {...props}>
          {children}
        </select>
        <span className="material-symbols-outlined select__icon" aria-hidden="true">
          {iconName}
        </span>
      </div>
    );

    if (!label) {
      return selectElement;
    }

    const wrapperClasses = ["select-field", block && "select-field--block"].filter(Boolean).join(" ");

    return (
      <label className={wrapperClasses}>
        <span className="select-field__label">{label}</span>
        {selectElement}
      </label>
    );
  },
);

Select.displayName = "Select";
